import React, { useState, useEffect } from "react";
import Header from "../layout/Header";
import order from "../../images/order1.png";
import order2 from "../../images/order2.png";
import order3 from "../../images/order3.png";
import chart from "../../images/chart.png";
import LeftPanel from "../layout/Leftpanel";
import { useTranslation } from "react-i18next";
import DashBoardCard from "./DashBoardCard";
import instance from "../../../WebApi/WebApi";
import { toast } from "react-toastify";
import SkeletonDashBoardCard from "../Loader/Skeleton/SkeletonDashBoardCard";

const Dashboardlayout = () => {
  const [userData, setUserData] = useState(null);
  const [dashboardData, setDashboardData] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    const jsonString = localStorage.getItem("gs3_User");

    const data = JSON.parse(jsonString);

    setUserData(data);
    getDashboardData();
  }, []);

  const getDashboardData = async () => {
    try {
      const response = await instance.post(`/customer/dashboard`, {});
      setDashboardData(response?.data?.data);
    } catch (err) {
      // console.log(err);
    }
  };

  return (
    <div className="container-fluid">
      <div className="dbMain">
        <LeftPanel />
        <div className="dbRight dbSingle">
          <Header
            title={t("welcome", { firstName: userData?.firstName })}
            description=""
          />
          <div className="row mb-3">
            <div className="db-section-header">Invoice Order Status</div>
            {!dashboardData ? (
              <>
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
              </>
            ) : (
              <>
                <DashBoardCard
                  card_title={"Orders"}
                  card_subtitle={"Not Created"}
                  card_data={dashboardData?.totalNumberOfOrders?.notCreated}
                />
                <DashBoardCard
                  card_title={"Orders"}
                  card_subtitle={"In Process"}
                  card_data={dashboardData?.totalNumberOfOrders?.inProcess}
                />
                <DashBoardCard
                  card_title={"Orders"}
                  card_subtitle={"Created"}
                  card_data={dashboardData?.totalNumberOfOrders?.created}
                />
                <DashBoardCard
                  card_title={"Orders"}
                  card_subtitle={"Recieved"}
                  card_data={dashboardData?.totalNumberOfOrders?.received}
                />
                <DashBoardCard
                  card_title={"Orders"}
                  card_subtitle={"Received with comments"}
                  card_data={
                    dashboardData?.totalNumberOfOrders?.receivedWithComment
                  }
                />
                <DashBoardCard
                  card_title={"Orders"}
                  card_subtitle={"Approved with Comments"}
                  card_data={
                    dashboardData?.totalNumberOfOrders?.approvedWithComment
                  }
                />
              </>
            )}
          </div>
          <div className="row mb-3">
            <div className="db-section-header">
              Product Information Management
            </div>
            {!dashboardData ? (
              <>
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
                <SkeletonDashBoardCard />
              </>
            ) : (
              <>
                <DashBoardCard
                  card_title={"Number of"}
                  card_subtitle={"Vendors"}
                  card_data={
                    dashboardData?.productInformationManagement
                      ?.totalNumberOfSuppliers
                  }
                />
                <DashBoardCard
                  card_title={"Number of"}
                  card_subtitle={"Products"}
                  card_data={`${dashboardData?.productInformationManagement?.totalNumberOfProducts} (${dashboardData?.productInformationManagement?.totalPercentOfProducts}%)`}
                />
                <DashBoardCard
                  card_title={"Products"}
                  card_subtitle={"with UNSPSC"}
                  card_data={`${
                    dashboardData?.productInformationManagement
                      ?.totalNumberOfProductsWithUnspsc
                  } (${Number(
                    dashboardData?.productInformationManagement
                      ?.totalPercentOfProductsWithUnspsc
                  )}%)`}
                />
                <DashBoardCard
                  card_title={"Products "}
                  card_subtitle={"With Value in Base unit"}
                  card_data={`${
                    dashboardData?.productInformationManagement
                      ?.totalNumberOfProductsWithValueInBaseUnit
                  } (${Number(
                    dashboardData?.productInformationManagement
                      ?.totalPercentOfProductsWithValueInBaseUnit
                  )}%)`}
                />
                <DashBoardCard
                  card_title={"Products"}
                  card_subtitle={
                    <>
                      With Value in CO<sub>2</sub>e unit
                    </>
                  }
                  card_data={`${
                    dashboardData?.productInformationManagement
                      ?.totalNumberOfProductsWithValueInCO2eUnit
                  } (${Number(
                    dashboardData?.productInformationManagement
                      ?.totalPercentOfProductsWithValueInCO2eUnit
                  )}%)`}
                />
                <DashBoardCard
                  card_title={"Products"}
                  card_subtitle={
                    <>
                      With value in KgCO<sub>2</sub>e unit
                    </>
                  }
                  card_data={`${
                    dashboardData?.productInformationManagement
                      ?.totalNumberOfProductsWithValueInKGCO2eUnit
                  } (${Number(
                    dashboardData?.productInformationManagement
                      ?.totalPercentOfProductsWithKGCo2Unit
                  )}%)`}
                />
                <DashBoardCard
                  card_title={"Products"}
                  card_subtitle={"with Name of Manufacturer"}
                  card_data={`${
                    dashboardData?.productInformationManagement
                      ?.totalNumberOfProductsWithSupplierName
                  } 
                  (${Number(
                    dashboardData?.productInformationManagement
                      ?.totalPercentOfProductsWithNameOfManufacturer
                  )}%)
                  `}
                />
                <DashBoardCard
                  card_title={"Products"}
                  card_subtitle={"with Manufacturer Country of Origin"}
                  card_data={`${
                    dashboardData?.productInformationManagement
                      ?.totalNumberOfProductsWithSupplierCountry
                  } (${Number(
                    dashboardData?.productInformationManagement
                      ?.totalPercentOfProductsWithSupplierCountry
                  )}%)`}
                />
              </>
            )}
          </div>
          {/* <div className="chartBg">
            <img src={chart} alt="" style={{ width: "100%" }} />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Dashboardlayout;
